import type { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';
import Tag, { type TagProps } from '@cobliteam/ui/components/Tag';
import Icon from '@cobliteam/ui/icons';
import { useTranslatedGeofences } from '../../Geofences';

type GeofenceTagProps = Omit<TagProps, 'label' | 'color'> & {
  geofenceType: GeofenceType;
};

const GeofenceTag = ({ geofenceType, ...props }: GeofenceTagProps) => {
  const { getTranslatedGeofencesDef } = useTranslatedGeofences();
  const { color, label, iconName } = getTranslatedGeofencesDef()[geofenceType];
  return <Tag color={color} icon={<Icon name={iconName} />} label={label} {...props} />;
};

export default GeofenceTag;
